/* Product page: the photograph viewer and swipe-strip progress (luren-product-media), and the colour name that
   follows the pointer over the swatches (luren-colours). */
class LurenProductMedia extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.grid = this.querySelector('[data-pm-grid]');
    this.viewer = this.querySelector('dialog');
    this.progress = this.querySelector('[data-pm-progress]');
    this.addEventListener(
      'click',
      (event) => {
        const opener = event.target.closest('[data-pm-open]');
        if (opener) return this.open(Number(opener.dataset.pmOpen));
        if (event.target.closest('[data-pm-close], [data-pm-shot]')) this.viewer.close();
      },
      { signal }
    );
    this.grid?.addEventListener('scroll', () => this.update(), { signal, passive: true });
    this.observer = new ResizeObserver(() => this.update());
    if (this.grid) this.observer.observe(this.grid);
  }

  open(index) {
    if (!this.viewer?.showModal) return;
    const shots = this.viewer.querySelectorAll('[data-pm-shot]');
    shots.forEach((shot, i) => {
      if (Math.abs(i - index) <= 1) shot.loading = 'eager';
    });
    this.viewer.showModal();
    this.viewer.scrollTop = 0;
    shots[index]?.scrollIntoView({ block: 'start' });
  }

  update() {
    if (!this.grid || !this.progress) return;
    const { scrollLeft, scrollWidth, clientWidth } = this.grid;
    const scrollable = scrollWidth > clientWidth + 2;
    this.progress.hidden = !scrollable;
    if (!scrollable) return;
    this.progress.style.setProperty('--pm-thumb', (clientWidth / scrollWidth).toFixed(4));
    this.progress.style.setProperty('--pm-left', (scrollLeft / scrollWidth).toFixed(4));
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }
}

class LurenColours extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.name = this.querySelector('[data-colour-name]');
    if (!this.name) return;
    const show = (event) => {
      const swatch = event.target.closest('[data-colour]');
      this.name.textContent = swatch ? swatch.dataset.colour : this.name.dataset.current;
    };
    const reset = () => (this.name.textContent = this.name.dataset.current);
    this.addEventListener('pointerover', show, { signal });
    this.addEventListener('pointerleave', reset, { signal });
    this.addEventListener('focusin', show, { signal });
    this.addEventListener('focusout', reset, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('luren-product-media')) customElements.define('luren-product-media', LurenProductMedia);
if (!customElements.get('luren-colours')) customElements.define('luren-colours', LurenColours);
